import { css } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorBackground } from '@cloudsuite/mosaic-shared/styles/colors.style.js'

const deliveryMatchDropoffMethodSelectorMap = {
  mapHeight: css`var(--csc-delivery-match-dropoff-method-selector-map-height, 450px)`
}

export const mapStyle = css`
  .map {
    height: ${deliveryMatchDropoffMethodSelectorMap.mapHeight};
  }

  gmp-map {
    height: 100%;
  }

  .selected-method {
    background: var(--cse-selectable-background-color, ${csColorBackground.primary});
    padding: ${csSpacing.spacing06};
  }

  .delivery-match-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${csSpacing.spacing05};
    flex: 1;
  }

  .hidden {
    display: none;
  }
`
